import { Phone, MessageCircle, MessagesSquare, Loader2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";

export function BottomBar({ phone, whatsapp, onChat, starting, listingId }) {
  const { lang } = useLang();
  const T = (ar, en) => (lang === "en" ? en : ar);
  const base = "flex-1 h-12 rounded-2xl font-bold flex items-center justify-center gap-2 text-sm sm:text-base transition-opacity";
  const wa = (whatsapp || "").replace(/[^0-9]/g, "");
  const track = (kind) => listingId && api.post(`/listings/${listingId}/contact`, { kind }).catch(() => {});
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-[#EFEBE0] shadow-[0_-6px_20px_rgba(0,0,0,0.05)]" data-testid="detail-bottom-bar">
      <div className="max-w-3xl mx-auto px-4 py-3 flex gap-2.5">
        <a href={phone ? `tel:${phone}` : undefined} onClick={() => track("call")} aria-disabled={!phone} className={`${base} bazaro-gradient text-white ${phone ? "" : "opacity-40 pointer-events-none"}`} data-testid="bottom-call">
          <Phone className="w-5 h-5" />{T("اتصال", "Call")}
        </a>
        <a href={wa ? `https://wa.me/${wa}` : undefined} target="_blank" rel="noreferrer" onClick={() => track("whatsapp")} aria-disabled={!wa} className={`${base} bg-[#25D366] text-white ${wa ? "" : "opacity-40 pointer-events-none"}`} data-testid="bottom-whatsapp">
          <MessageCircle className="w-5 h-5" />{T("واتساب", "WhatsApp")}
        </a>
        <button onClick={() => { track("chat"); onChat(); }} disabled={starting} className={`${base} bg-[#E8EFEA] text-[#0F4D32]`} data-testid="bottom-chat">
          {starting ? <Loader2 className="w-5 h-5 animate-spin" /> : <MessagesSquare className="w-5 h-5" />}{T("مراسلة البائع", "Message seller")}
        </button>
      </div>
    </div>
  );
}
